import React from "react";
import ServiceProviderItem from "./service-provider-item.component";
import { Business, House } from "store/service/service.types";
import boximg from "assets/img/serviceprofileboximg.png";
import { usePagination } from "utils/hooks/usePagination";
import Pagination from "components/pagination";

interface ProvidersProps {
  providers?: Business[] | null;
  houses?: House[] | null;
  emptyServices: number[];
}

const Providers: React.FC<ProvidersProps> = ({
  providers,
  houses,
  emptyServices,
}) => {
  const isHouse = houses;
  const { page, totalPages, setPage, paginatedItems } = usePagination<
    Business | House
  >(providers ?? houses!, 12);
  return (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 py-14">
        {paginatedItems === null
          ? emptyServices.map((_, i) => (
              <div className="card bg-base-100 shadow-xl" key={i}>
                <div className="flex flex-col gap-4 w-full">
                  <div className="skeleton h-32 w-full"></div>
                  <div className="skeleton h-4 w-28"></div>
                  <div className="skeleton h-4 w-full"></div>
                  <div className="skeleton h-4 w-full"></div>
                </div>
              </div>
            ))
          : paginatedItems.map((service) =>
              isHouse ? (
                <ServiceProviderItem
                  house={service as House}
                  key={service._id}
                />
              ) : (
                <ServiceProviderItem
                  item={service as Business}
                  key={service._id}
                />
              )
            )}
      </div>
      {paginatedItems?.length === 0 && (
        <div className="bg-white dark:bg-casagray-900 h-[26.25rem] rounded-lg flex flex-col justify-center items-center">
          <img src={boximg} alt="Box img" width={98} height={98} />
          <p className="font-medium text-black dark:text-white text-lg">
            {isHouse ? "No houses listed here yet" : "No Provider found..."}
          </p>
        </div>
      )}

      <div className="mt-2">
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </div>
    </>
  );
};

export default Providers;
